import React, { useState } from "react";
import "./GuestInfo.css";
import { useNavigate,useLocation } from "react-router-dom";

const GuestInfo = () => {
  const navigate = useNavigate();
  const location = useLocation();


  const packageName = location.state?.packageName|| "ZikRme Dream Vacation";
const date = location.state?.date;

  const [formData, setFormData] = useState({
    fullName: "",
    companyName: "",
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    traveler: "I am the main traveler",
    businessTrip: "No",
    requests: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Only numbers allowed in phone
    if (name === "phone") {
      if (!/^[0-9]*$/.test(value)) return;
    }

    setFormData({
      ...formData,
      [name]: value,
    });

    setErrors({
      ...errors,
      [name]: "",
    });
  };

  const validate = () => {
    let newErrors = {};

    if (!formData.firstName.trim()) {
      newErrors.firstName = "First name is required";
    }

    if (!formData.lastName.trim()) {
      newErrors.lastName = "Last name is required";
    }

    if (!formData.email) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Enter valid email";
    }

    if (!formData.phone) {
      newErrors.phone = "Phone number is required";
    } else if (formData.phone.length !== 10) {
      newErrors.phone = "Phone must be 10 digits";
    }

    // If booking for someone else → Full Name required
    if (formData.traveler === "Booking for someone else") {
      if (!formData.fullName.trim()) {
        newErrors.fullName = "Main traveler name is required";
      }
    }

    // If business trip = Yes → Company required
    if (formData.businessTrip === "Yes") {
      if (!formData.companyName.trim()) {
        newErrors.companyName = "Company name is required";
      }
      if (!formData.gstAddress.trim()) {
        newErrors.gstAddress = "Address name is required";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = () => {
    if (validate()) {
       navigate("/payment", {
         state: {
           packageName: packageName,
           email: formData.email,
           date:date,
           amount: "23600",
         },
       });
    }
  };

  return (
    <div className="guest-container">
      <div className="guest-box">
        <h2 className="guest-heading">Guest Information</h2>

        <p className="guest-signup">
          Not signed in? <span>Login</span> or <span>Register</span> for a
          faster booking experience.
        </p>

        {/* Name */}
        <div className="guest-row">
          <div>
            <input
              type="text"
              name="firstName"
              placeholder="First Name"
              value={formData.firstName}
              onChange={handleChange}
            />
            {errors.firstName && <p className="error">{errors.firstName}</p>}
          </div>

          <div>
            <input
              type="text"
              name="lastName"
              placeholder="Last Name"
              value={formData.lastName}
              onChange={handleChange}
            />
            {errors.lastName && <p className="error">{errors.lastName}</p>}
          </div>
        </div>

        {/* Email */}
        <label>Email Address</label>
        <input
          type="email"
          name="email"
          placeholder="alex@example.com"
          value={formData.email}
          onChange={handleChange}
        />
        {errors.email && <p className="error">{errors.email}</p>}

        {/* Phone */}
        <div className="guest-row">
          <select>
            <option>India (+91)</option>
          </select>

          <div style={{ width: "100%" }}>
            <input
              type="text"
              name="phone"
              placeholder="Phone Number"
              value={formData.phone}
              onChange={handleChange}
            />
            {errors.phone && <p className="error">{errors.phone}</p>}
          </div>
        </div>

        {/* Traveler */}
        <label>Who is traveling?</label>
        <select
          name="traveler"
          value={formData.traveler}
          onChange={handleChange}
        >
          <option>I am the main traveler</option>
          <option>Booking for someone else</option>
        </select>

        {/* Show only if booking for someone else */}
        {formData.traveler === "Booking for someone else" && (
          <>
            <label>Main Traveler's Full Name</label>
            <input
              type="text"
              name="fullName"
              placeholder="Enter guest's name"
              value={formData.fullName}
              onChange={handleChange}
            />
            {errors.fullName && <p className="error">{errors.fullName}</p>}
          </>
        )}

        {/* Business Trip */}
        <label>Is this a business trip?</label>
        <select
          name="businessTrip"
          value={formData.businessTrip}
          onChange={handleChange}
        >
          <option>No</option>
          <option>Yes</option>
        </select>

        {/* Show only if business trip */}
        {formData.businessTrip === "Yes" && (
          <>
            <label>Company Name</label>
            <input
              type="text"
              name="companyName"
              placeholder="e.g. ZikRme Corp"
              value={formData.companyName}
              onChange={handleChange}
            />
            {errors.companyName && (
              <p className="error">{errors.companyName}</p>
            )}
            <label>Address</label>
            <input
              type="text"
              name="Address"
              placeholder="enter address"
              value={formData.gstAddress}
              onChange={handleChange}
            />
            {errors.companyName && <p className="error">{errors.gstAddress}</p>}
          </>
        )}

        {/* Requests */}
        <label>Special Requests (Optional)</label>
        <textarea
          name="requests"
          placeholder="Requests are subject to availability."
          value={formData.requests}
          onChange={handleChange}
        ></textarea>

        <p className="guest-note">
          Note: Special requests cannot be guaranteed and may depend on
          availability.
        </p>

        <button className="payment-btn" onClick={handleSubmit}>
          Continue to Payment
        </button>
      </div>
    </div>
  );
};

export default GuestInfo;
